import type { SerializedStyles } from '@emotion/react'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, css, styled } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import type { To } from 'react-router'

import { COLORS, ICONS, LinkUnstyled, remUnit, unit, Z_INDEX } from '@hcr/ui'

import { LayoutBase } from '../layout-base'

interface LayoutNavigationBackProps extends PropsWithChildren {
  arrowVariant: 'outlined' | 'text'
  iconVariant?: IconDefinition
  to: To
}

export const LayoutNavigationBack: FC<LayoutNavigationBackProps> = ({ arrowVariant, children, iconVariant, to }) => {
  const { t } = useTranslation()

  return (
    <LayoutBase>
      <ArrowLinkIcon to={to} css={arrowIconVariantCss[arrowVariant]} aria-label={t('navigation.back')}>
        <FontAwesomeIcon icon={iconVariant || ICONS.farArrowLeft} />
      </ArrowLinkIcon>
      <Box component='main' height='100%'>
        {children}
      </Box>
    </LayoutBase>
  )
}

const ArrowLinkIcon = styled(LinkUnstyled)`
  width: ${unit(14)};
  height: ${unit(14)};
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: ${unit(3)};
  top: ${unit(4)};
  z-index: ${Z_INDEX.navigation};
  font-size: ${remUnit(6)};
`

const arrowIconVariantCss: Record<LayoutNavigationBackProps['arrowVariant'], SerializedStyles> = {
  outlined: css`
    background-color: ${COLORS.white};
    border: ${unit(0.5)} solid ${COLORS.black};
  `,
  text: css`
    background: none;
    border: none;
  `,
}
